import Dexie from "dexie";
import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalTankRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.TANKS);
  }

  async listByVesselId(vesselId) {
    return this.table.where("vesselId").equals(vesselId).toArray();
  }

  async listActiveByVesselId(vesselId) {
    return this.table
      .where("[vesselId+tankType]")
      .between([vesselId, Dexie.minKey], [vesselId, Dexie.maxKey])
      .filter((tank) => tank.active)
      .toArray();
  }
}
